@if (loaded) {
  <div class="modal-content">
    <div class="modal-header bg-tertiary">
      <h6 class="modal-title fw-bold" id="addConfigurationModalLabel">{{ isCreate() ? 'Add' : 'Edit' }} Token</h6>
      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
    </div>
    <div class="modal-body">
      <form [formGroup]="form" id="form" (ngSubmit)="onSubmit()">
        <div class="row gy-3">
          <div class="col-12">
            <label for="newTokenTitle" class="form-label fw-bold small">Token Title</label>
            <div class="input-group mb-3">
              <span class="input-group-text"><i class="bi bi-pencil"></i></span>
              <input type="text" class="form-control" id="newTokenTitle" placeholder="Enter token title"
                formControlName="label">
            </div>
          </div>
          <div class="col-4">
            <label for="subid" class="form-label fw-bold small">SubID</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-filter"></i></span>
              <input type="text" class="form-control" id="subid" formControlName="subid">
            </div>
          </div>
          <div class="col-4">
            <label class="form-label fw-bold small">Preping</label>
            <app-input-switch formControlName="preping"></app-input-switch>
          </div>
          <div class="col-4">
            <label class="form-label fw-bold small">Hide reactivation response code</label>
            <app-input-switch formControlName="hideReactivationResponseCode"></app-input-switch>
          </div>
        </div>
      </form>
    </div>
    <div class="modal-footer bg-tertiary">
      <button type="button" class="btn btn-outline-primary fw-bold" data-bs-dismiss="modal">Cancel</button>
      <button form="form" type="submit" class="btn btn-primary fw-bold">
        {{ isCreate() ? 'Create' : 'Update' }}
      </button>
    </div>
  </div>
}
